import Home from './pages/Home';
import { WhatsAppProvider } from './context/WhatsAppContext';

export default function App() {
  return (
    <WhatsAppProvider>
      <Home />
    </WhatsAppProvider>
  );
}